import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { getMenuCategoryIcon } from '@/lib/menuCategoryIcons';
import { translateMenuTerm } from '@/i18n/translateMenuContent';

export default function CatalogCategoryFilters({
  standard,
  premium,
  categories,
  selectedCategory,
  onSelectCategory,
  accent,
  branding: b,
  business,
}) {
  const { t, i18n } = useTranslation();
  const lng = i18n.language;
  const allLabel = t('catalog.all');
  const labelFor = (name) => translateMenuTerm(name, lng);
  const iconOptions = business ? { business } : undefined;
  if (standard) {
    return (
      <div className="flex gap-2 overflow-x-auto pb-4 mb-6 scrollbar-hide">
        <Button
          variant={selectedCategory === 'all' ? 'default' : 'outline'}
          onClick={() => onSelectCategory('all')}
          className="rounded-full whitespace-nowrap"
          style={selectedCategory === 'all' ? { backgroundColor: accent } : {}}
        >
          {allLabel}
        </Button>
        {categories.map((cat) => (
          <Button
            key={cat.id}
            variant={selectedCategory === cat.id ? 'default' : 'outline'}
            onClick={() => onSelectCategory(cat.id)}
            className="rounded-full whitespace-nowrap"
            style={selectedCategory === cat.id ? { backgroundColor: accent } : {}}
          >
            {labelFor(cat.name)}
          </Button>
        ))}
      </div>
    );
  }

  if (!premium) return null;

  return (
    <div className="flex gap-4 overflow-x-auto pb-4 mb-6 scrollbar-hide px-1">
      <button
        type="button"
        onClick={() => onSelectCategory('all')}
        className="flex flex-col items-center gap-1.5 min-w-[4.75rem] shrink-0"
      >
        {(() => {
          const Icon = getMenuCategoryIcon('Todos', iconOptions);
          const sel = selectedCategory === 'all';
          return (
            <>
              <div
                className="flex h-14 w-14 items-center justify-center rounded-full border-2 shadow-sm transition-transform active:scale-95"
                style={{
                  backgroundColor: sel ? accent : b.card_background_color,
                  borderColor: sel ? accent : b.card_border_color,
                }}
              >
                <Icon
                  className="h-6 w-6"
                  style={{ color: sel ? b.button_text_color : accent }}
                  aria-hidden
                />
              </div>
              <span
                className="max-w-[5.5rem] text-center text-[11px] leading-tight line-clamp-2"
                style={{ color: b.text_color }}
              >
                {allLabel}
              </span>
            </>
          );
        })()}
      </button>
      {categories.map((cat) => {
        const Icon = getMenuCategoryIcon(cat.name, iconOptions);
        const sel = selectedCategory === cat.id;
        return (
          <button
            key={cat.id}
            type="button"
            onClick={() => onSelectCategory(cat.id)}
            className="flex flex-col items-center gap-1.5 min-w-[4.75rem] shrink-0"
          >
            <div
              className="flex h-14 w-14 items-center justify-center rounded-full border-2 shadow-sm transition-transform active:scale-95"
              style={{
                backgroundColor: sel ? accent : b.card_background_color,
                borderColor: sel ? accent : b.card_border_color,
              }}
            >
              <Icon
                className="h-6 w-6"
                style={{ color: sel ? b.button_text_color : accent }}
                aria-hidden
              />
            </div>
            <span
              className="max-w-[5.5rem] text-center text-[11px] leading-tight line-clamp-2"
              style={{ color: b.text_color }}
            >
              {labelFor(cat.name)}
            </span>
          </button>
        );
      })}
    </div>
  );
}
